import { Datagrid, DateField, EditButton, List, ResourceProps, ShowButton, TextField } from 'react-admin';

import { SendNotificationButton } from 'components';

const NotificationsList = (props: ResourceProps) => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField label="Название" source="title" />
        <TextField label="ID уведомдения" source="id" />
        <TextField label="Заголовок уведомления" source="notificationTitle" />
        <DateField locales="rus" label="Создано" source="createdAt" />
        <SendNotificationButton />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default NotificationsList;
